import { call, takeLatest } from "redux-saga/effects";
import * as paymentApis from "../apis/paymentApis"
import { PLANS_LIST, RAZORPAY_CREATE_ORDER, RAZORPAY_PAYMENT_SUCCESS, STRIPE_CHECKOUT, STRIPE_PAYMENT_SUCCESS, SUBSCRIPTIONS_LIST } from "../actions/types";


export function* stripeCheckoutWorker(action) {
    try {
        const res = yield call(paymentApis.stripeCheckoutApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* stripePaymentSuccessWorker(action) {
    try {
        const res = yield call(paymentApis.stripePaymentSuccessApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* plansListWorker(action) {
    try {
        const res = yield call(paymentApis.plansListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* subscriptionListWorker(action) {
    try {
        const res = yield call(paymentApis.subscriptionListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* razorpayCreateOrderWorker(action) {
    try {
        const res = yield call(paymentApis.razorpayCreateOrderApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* razorpayPaymentSuccessWorker(action) {
    try {
        const res = yield call(paymentApis.razorpayPaymentSuccessApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


/**Watcher Func */
export function* stripeCheckoutWatcher() {
    yield takeLatest(STRIPE_CHECKOUT, stripeCheckoutWorker);
}

export function* stripePaymentSuccessWatcher() {
    yield takeLatest(STRIPE_PAYMENT_SUCCESS, stripePaymentSuccessWorker);
}


export function* plansListWatcher() {
    yield takeLatest(PLANS_LIST, plansListWorker);
}

export function* subscriptionListWatcher() {
    yield takeLatest(SUBSCRIPTIONS_LIST, subscriptionListWorker);
}

export function* razorpayCreateOrderWatcher() {
    yield takeLatest(RAZORPAY_CREATE_ORDER, razorpayCreateOrderWorker);
}

export function* razorpayPaymentSuccessWatcher() {
    yield takeLatest(RAZORPAY_PAYMENT_SUCCESS, razorpayPaymentSuccessWorker);
}
